window.addEventListener("DOMContentLoaded", () => {
  function setContactOption(modal, formId, optionName, value) {
    if (!value || !modal) return;

    const radio = modal.querySelector(
      `.swatch[data-contact-option="${optionName}"] input[type="radio"][value="${CSS.escape(value)}"]`
    );
    const hidden = modal.querySelector(`#${CSS.escape(formId)}-${optionName}`);

    if (!radio) return;

    radio.checked = true;
    if (hidden) hidden.value = value;
  }

  function syncVariantFields(modal, button) {
    const formId = modal.querySelector("form")?.id;
    if (!formId) return;

    const productSection = button.closest("[data-section-type='product']");
    const optionSelectors = (
      productSection || document
    ).querySelectorAll("[data-product-form] .single-option-selector");

    optionSelectors.forEach((select) => {
      const name = (select.getAttribute("data-option-name") || "").toLowerCase();
      const value = select.value || "";

      if (name === "colour" || name === "color") {
        setContactOption(modal, formId, "colour", value);
      }

      if (name === "size") {
        setContactOption(modal, formId, "size", value);
      }
    });
  }

  function findModal(button) {
    const modalId = button.getAttribute("data-modal-target");

    if (modalId) {
      return document.getElementById(modalId);
    }

    return document.querySelector(".contact-hannas-modal");
  }

  document.addEventListener("click", (event) => {
    const openBtn = event.target.closest("a.modal--openBtn");
    if (!openBtn) {
      const closeBtn = event.target.closest("[data-modal-close]");
      if (closeBtn) {
        event.preventDefault();

        const modalId = closeBtn.getAttribute("data-modal-close");
        const modal = modalId
          ? document.getElementById(modalId) || closeBtn.closest("dialog")
          : closeBtn.closest("dialog");

        if (modal && typeof modal.close === "function") modal.close();
      }
      return;
    }

    if (openBtn.closest("#modal-quick-view")) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const modal = findModal(openBtn);
    if (!modal || typeof modal.showModal !== "function") return;

    syncVariantFields(modal, openBtn);
    modal.showModal();
  });

  document.addEventListener("change", (event) => {
    const radio = event.target.closest(
      '.contact-hannas-modal .swatch[data-contact-option] input[type="radio"]'
    );
    if (!radio) return;

    const modal = radio.closest(".contact-hannas-modal");
    const formId = modal?.querySelector("form")?.id;
    const optionName = radio
      .closest("[data-contact-option]")
      ?.getAttribute("data-contact-option");

    if (!modal || !formId || !optionName) return;

    const hidden = modal.querySelector(`#${CSS.escape(formId)}-${optionName}`);
    if (hidden) hidden.value = radio.value;
  });
});
